import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Currencies from '../../../../Core/Enums/Currencies';
import { addVat } from '../../../../Core/Services/PaymentService';
import { useGlobal } from '../../../../Core/GlobalState/Store';

import ContainerInfoComponent from '../../SizeSelection/ContainerInfoComponent';
import CanvasMap from '../CanvasMap/CanvasMap';
import LevelNavigationButtons from '../LevelNavigationButtons';
import Sidebar from '../../../ReusableComponents/Sidebar';

export function PlacementSelectBodyComponent({
  roomList,
  selectedSize,
  selectedLevel,
  mapService,
  setSelectedSize,
  setCurrentVisibleLevel,
  siteMap,
  setSelectedLevel,
  showPlacementBody,
  setShowPlacementBody,
  handleNext,
}) {
  const levelCount = siteMap?.length ?? 0;
  const safeLevel = Math.max(0, Math.min(selectedLevel, levelCount - 1));
  const { t, i18n } = useTranslation();
  const { room } = useGlobal();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Open sidebar when a room is selected on the map
  useEffect(() => {
    if (room) {
      setSidebarOpen(true);
    }
  }, [room]);

  // Only render the selected layer
  let firstLayer = mapService.trimMatrix(siteMap[safeLevel] || []);

  return (
    <div className="grid grid-cols-1 md:grid-cols-12 ">
      <div className="col-span-1 md:col-span-7 !border !border-solid border-gray-300">
        <div className="w-full flex flex-col p-4 h-full">
          <div className="flex items-center w-full justify-between mb-2">
            <LevelNavigationButtons
              safeLevel={safeLevel}
              setCurrentLevel={setSelectedLevel}
            />
            <div
              className="ml-0 flex items-center text-black p-4 text-sm"
              style={{ backgroundColor: '#DDDDDD' }}
            >
              {selectedSize
                ? t('container_from_price', {
                    price: addVat(selectedSize.fromPrice).toLocaleString(
                      i18n.language,
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }
                    ),
                    currency: Currencies.getCodeByValue(selectedSize.currency),
                  })
                : ''}
            </div>
          </div>
          <CanvasMap
            firstLayer={firstLayer}
            setSelectedLevel={setSelectedLevel}
            setSelectedSizeType={setSelectedSize}
          />
        </div>
      </div>

      {/* Desktop: show inline */}
      <div className="hidden md:block md:col-span-5">
        {selectedSize && (
          <ContainerInfoComponent
            roomList={roomList}
            selectedSize={selectedSize}
            selectedLevel={selectedLevel}
            setSelectedLevel={setSelectedLevel}
            showPlacementBody={showPlacementBody}
            setShowPlacementBody={setShowPlacementBody}
            handleNext={handleNext}
          />
        )}
      </div>

      {/* Mobile: show in sidebar */}
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        onOpen={selectedSize ? () => setSidebarOpen(true) : null}
        openLabel={t('view_details')}
      >
        {selectedSize && (
          <ContainerInfoComponent
            roomList={roomList}
            selectedSize={selectedSize}
            selectedLevel={selectedLevel}
            setSelectedLevel={setSelectedLevel}
            showPlacementBody={showPlacementBody}
            setShowPlacementBody={setShowPlacementBody}
            handleNext={handleNext}
            onClose={() => setSidebarOpen(false)}
          />
        )}
      </Sidebar>
    </div>
  );
}
